import React from "react";
import { OperationsDashboard } from "../components/OperationsDashboard";
import { CustomDashboardProps } from "../utils/types";

export const dashboard: CustomDashboardProps = {
  title: "Utilization Detailed View",
  charts: [],
  filters: [],
  Component: () =>
    React.createElement(OperationsDashboard, {
      variant: "utilization_analysis",
    }),
};
